import { announcement } from './announcement'
import { slideshow } from './slideshow'

export const cms = {
  announcement,
  slideshow
}
